<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop no-close-on-esc hide-header-close hide-footer
      dialog-class="my-1" :id="theme" header-class="my-class p-1" body-class="pt-1 pb-0"
      size="lg" title="5m歩行テスト">
      <div class="row px-3">
        <div class="col-12">
          <div class="text-center">
            <span>患者ID: {{ user.patient_id }}</span>
            <span class="ms-3">患者名: {{ user.information?.fullname }}</span>
            <div>
              <ul class="d-inline-block text-start">
                <li>測定は2回行います(2回の平均速度が計 算されます)。</li>
                <li>スタート・ストップ・一時保存で1回の測 定が完了します。</li>
                <li>対象者は赤い点線を目印に画面中央に映る ように撮影します。</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-12 border border-1 rounded text-center overflow-hidden p-0">
          <div v-if="errorMessage" class="py-4">{{ errorMessage }}</div>
          <div v-else class="video-container position-relative">
            <div class="separator-wrapper">
              <div class="separator-line"></div>
            </div>
            <video class="p-0 m-auto w-100 bg-dark" ref="camera" autoplay
              style="object-fit: cover; height: 540px;"></video>
          </div>
          <div class="position-relative">
            <div class="record-sign float-start ms-1 mt-1" :class="{invisible: !recording}"></div>
            <span class="font-size-20 font-weight-semibold ms-n3" style="font-family: ui-monospace">
              {{ displayTimer }}
            </span>
            <div class="position-absolute" style="right: 0; top: 0;">
              <b-form-select class="border-0 form-select-sm bg-opacity-0" v-model="selectedCameraId" :options="cameras"
                @change="changeCamera"></b-form-select>
            </div>
          </div>
        </div>

        <div class="col-12 mt-2 p-0">
          <div class="row g-3">
            <div class="col-6">
              <b-button class="w-100 font-weight-semibold" type="button" variant="primary"
                @click="recording ? stop() : start()">
                {{ recording ? 'ストップ' : 'スタート' }}
              </b-button>
            </div>
            <div class="col-6">
              <b-button class="w-100 font-weight-semibold" type="button" variant="warning" @click="restart">リセット
              </b-button>
            </div>

            <div class="col-12 mt-2 text-center">
              <label class="col-4 pt-2">
                歩行速度：<span class="text-decoration-underline">{{ duration.toFixed(2) }}m/秒</span>
              </label>
            </div>

            <div class="col-12 p-0">
              <b-button class="w-100 font-weight-semibold" type="button" variant="outline-secondary"
                :disabled="file === null || items.length >= 2 || uploading" @click="addVideo">
                <i class='fa fa-spinner fa-spin' v-show="uploading"></i>
                一時保存
              </b-button>
            </div>
          </div>
        </div>

        <template v-if="items.length">
          <div class="col-12 mt-2 p-0" v-for="(item, index) in items" :key="item.fileUrl">
            <div class="row g-0">
              <label class="col-2 mt-2">{{ index + 1 }}回目</label>
              <label class="col-2 mt-2"><b>{{ item.duration.toFixed(2) }}m/秒</b></label>
              <div class="col-4">
                <b-button class="w-100" type="button" variant="outline-primary" :href="item.fileUrl" target="_blank"><i
                  class="bx bxs-videos"></i> 動画
                </b-button>
              </div>
              <div class="col-4 ps-3">
                <b-button class="w-100" type="button" variant="outline-warning" @click="removeVideo(index)">
                  <i class='bx bxs-trash'></i> クリアー
                </b-button>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-12 mt-2 p-0 text-center">アイテムはありません</div>
        </template>

        <div class="col-12 mt-2 text-center">
          <label>
            結果（平均）：
            <span class="text-decoration-underline" :style="{ color: displayAvgDuration() <= 1 && displayAvgDuration() != 0 ? 'red' : ''}">{{ displayAvgDuration() }}m/秒</span>
          </label>
        </div>
      </div>

      <div class="w-100">
        <FiveMeterBtns :disabled="items.length === 0 || aiLoading" @submit="submit()" @close="closeModal()"
          @removeAll="removeAllVideos"/>
      </div>

      <!--歩行分析ボタン-->
      <div class="row pt-3" v-if="user.is_plus">
        <div class="col">
          <b-button class="btn btn-primary w-100 font-weight-semibold" :disabled="items.length === 0"
            type="button" @click="getHokouAIResult()">
            <i class='fa fa-spinner fa-spin' v-show="aiLoading"></i>
            歩行分析
          </b-button>
        </div>
      </div>

      <div class="pt-3">
        <HokouAiResult :is-show="isShowAi" :aiError="aiError" :loading="aiLoading"
          :user="user" :result="aiResult" :firstResult="firstResult" :latestResult="latestResult" />
      </div>

      <div class="w-100 pb-3" v-if="isShowAi">
        <div class="row">
          <div class="col-12 text-center">
            <label>
              結果（平均）：
              <span class="text-decoration-underline" :style="{ color: displayAvgDuration() <= 1 && displayAvgDuration() != 0 ? 'red' : ''}">{{ displayAvgDuration() }}m/秒</span>
            </label>
          </div>
        </div>

        <hr class="mt-1">
        <FiveMeterBtns :disabled="items.length === 0 || aiLoading" @submit="submit()" @close="closeModal()"
          @removeAll="removeAllVideos"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {userMethods} from "@/state/helpers";
import {round} from "lodash";
import {mixin} from "@/helpers/Vue-Mixin";
import api from '@/api';
import moment from "moment";
import HokouAiResult from "@/components/widgets/hokou-ai.vue";
import FiveMeterBtns from "@/components/widgets/five-meter-btns.vue";

let cameraStream = null;
let mediaRecorder = null;
let blobsRecorded = [];
let recommendMimetype = null;

export default {
  mixins: [mixin],
  components: {
    HokouAiResult, FiveMeterBtns
  },
  props: ['isShow', 'user'],
  data() {
    return {
      show: false,
      startAt: 0,
      timer: 0,
      duration: 0,
      items: [],
      recording: false,
      uploading: false,
      errorMessage: '',
      file: null,
      selectedCameraId: null,
      cameras: [],

      isShowAi: false,
      aiLoading: false,
      aiError: '',
      aiResult: null,
      firstResult: {},
      latestResult: {},
    };
  },

  computed: {
    theme() {
      return this.$store.state.theme;
    },
    displayTimer: function () {
      return this.displaySeconds(this.timer);
    },
  },

  watch: {
    isShow: {
      handler(value) {
        this.show = value;
        if (value) {
          this.clearRecordingData();
          this.initCamera().then(() => this.listCameras().then(() => this.initCamera()));
        }
      },
    },
  },

  methods: {
    ...userMethods,

    currentSeconds() {
      return round(new Date().getTime() / 1000, 2);
    },

    getAllSupportedMimeTypes(...mediaTypes) {
      if (!mediaTypes.length) mediaTypes.push(...['video', 'audio'])
      const FILE_EXTENSIONS = ['mp4', 'webm', 'ogg', 'x-matroska']
      const CODECS = ['vp9', 'vp9.0', 'vp8', 'vp8.0', 'avc1', 'av1', 'h265', 'h.265', 'h264', 'h.264', 'opus']

      return [...new Set(
        FILE_EXTENSIONS.flatMap(ext =>
          CODECS.flatMap(codec =>
            mediaTypes.flatMap(mediaType => [
              {mimeType: `${mediaType}/${ext};codecs:${codec}`, ext: ext},
              {mimeType: `${mediaType}/${ext};codecs=${codec}`, ext: ext},
              {mimeType: `${mediaType}/${ext};codecs:${codec.toUpperCase()}`, ext: ext},
              {mimeType: `${mediaType}/${ext};codecs=${codec.toUpperCase()}`, ext: ext},
              {mimeType: `${mediaType}/${ext}`, ext: ext},
            ]),
          ),
        ),
      )].filter(variation => MediaRecorder.isTypeSupported(variation.mimeType))
    },

    async listCameras() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.cameras = devices.filter(device => device.kind === 'videoinput')
        .map((camera, index) => ({
          value: camera.deviceId,
          name: camera.label,
          text: `Camera ${index + 1}`
        }))
        .sort((a, b) => {
          const isBackA = a.name.includes('facing back');
          const isBackB = b.name.includes('facing back');
          if (isBackA && !isBackB) {
            return -1;
          } else if (!isBackA && isBackB) {
            return 1;
          } else {
            return 0;
          }
        });

      this.selectedCameraId = this.cameras.length > 1 ? this.cameras[1]?.value : this.cameras[0]?.value;

    },

    async changeCamera() {
      this.reset();
      await this.initCamera();
    },

    async initCamera() {
      if (cameraStream) {
        cameraStream.getTracks().forEach(track => {
          track.stop();
        });

        cameraStream = null;
      }

      try {
        cameraStream = await navigator.mediaDevices.getUserMedia({
          video: {deviceId: this.selectedCameraId ? {exact: this.selectedCameraId} : undefined},
          audio: false
        });
      } catch (error) {
        this.errorMessage = "このブラウザはビデオ録画をサポートしていません";
        return;
      }

      this.$refs.camera.srcObject = cameraStream;

      const supportedMimeTypes = this.getAllSupportedMimeTypes('video');
      recommendMimetype = supportedMimeTypes[0];

      mediaRecorder = new MediaRecorder(cameraStream, {mimeType: recommendMimetype.mimeType});

      mediaRecorder.addEventListener('dataavailable', (e) => {
        blobsRecorded.push(e.data);
      });

      mediaRecorder.addEventListener('start', () => {
        this.clearRecordingData();
        this.recording = true;
        this.startAt = this.currentSeconds();
        this.countTimer();
      });

      mediaRecorder.addEventListener('stop', () => {
        this.recording = false;
        this.file = new Blob(blobsRecorded, {type: recommendMimetype.mimeType});
        this.duration = round(this.timer / 5, 2);
        this.timer = 0;
      });

      return cameraStream;
    },

    countTimer() {
      if (this.recording) {
        setTimeout(() => {
          this.timer = round(this.currentSeconds() - this.startAt, 2);
          this.countTimer();
        }, 10);
      }
    },

    start() {
      mediaRecorder?.start(300);
    },

    stop() {
      if (this.recording) {
        mediaRecorder?.stop();
      }
    },

    reset() {
      this.stop();

      setTimeout(() => this.clearRecordingData(), 11);
    },

    restart() {
      this.reset();
    },

    displaySeconds(seconds) {
      return Number(seconds).toFixed(2);
    },

    avgDuration() {
      const values = this.items.map(i => i.duration);
      const duration = values.length ? (values.reduce((a, b) => a + b, 0) / values.length) : 0;
      return round(duration, 2);
    },
    displayAvgDuration() {
      return this.avgDuration().toFixed(2);
    },
    async addVideo() {
      this.uploading = true;

      const path = await this.uploadVideo();

      this.items.push({duration: this.duration, time: this.timer, path: path, fileUrl: URL.createObjectURL(this.file)});
      this.reset();

      this.aiResult = null;

      this.uploading = false;
    },

    removeVideo(index) {
      this.items.splice(index, 1);

      this.aiResult = null;
    },

    removeAllVideos() {
      this.items = [];

      this.isShowAi = false;
      this.aiResult = null;
      this.aiError = '';
    },

    clearRecordingData() {
      this.recording = false;
      blobsRecorded = [];
      this.file = null;
      this.timer = 0;
      this.duration = 0;
      this.startAt = 0;
    },

    stopCamera() {
      if (cameraStream) {
        cameraStream.getTracks().forEach(track => {
          track.stop();
        });

        cameraStream = null;
      }
    },

    closeModal() {
      this.stopCamera();
      this.reset();

      this.$emit("close");
      this.show = false;
    },

    async uploadVideo() {
      return await api.uploadFile(`rokomo-test/${this.user.patient_id}-${moment(Date.now()).format("YYYYMMDDHHmmssSSS")}.mp4`, this.file);
    },

    async submit() {

      const items = this.items.map(i => ({
        result: i.duration,
        time: i.time,
        video: i.path,
      }));

      const aiResult = !this.aiError ? this.aiResult : null;
      this.$emit("save", this.displayAvgDuration(), items, aiResult, this.firstResult, this.latestResult);

      this.closeModal();
    },

    async getHokouAIResult() {
      if (!this.aiResult) {
        this.aiLoading = true;
        this.aiError = '';

        const data = {"videos": this.items.map((item) => item.path)};

        try {
          const res = await api.postRCHokouAPI(data);

          const result = res.data.data;

          if (result) {
            this.aiResult = {...result, date: moment().format('YYYY/MM/DD')};

            await this.getFirstAndlatestResults();
          }

          if (result.message) {
            throw result.message;
          }

          this.showResult();
        } catch (error) {
          this.aiError = '分析エラーです。再度、撮影してください';

          window.toastr.error(this.aiError);
        }

        this.aiLoading = false;
      }
    },

    showResult() {
      this.isShowAi = true;
    },

    async getFirstAndlatestResults() {
      const res = await api.firstAndLast(this.user.id);

      if (!res.data) {
        return;
      }

      const rokomos = res.data;

      if (rokomos?.first?.five_meter_ai) {
        this.firstResult = {
          ...rokomos.first.five_meter_ai,
          date: moment(rokomos.first.created_at).format('YYYY/MM/DD')
        };
      }

      if (rokomos?.latest?.five_meter_ai) {
        this.latestResult = {
          ...rokomos.latest.five_meter_ai,
          date: moment(rokomos.latest.created_at).format('YYYY/MM/DD')
        };
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-header {
  background: #007e41;
  height: 70px;
}

::v-deep .modal-title {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: 700;
  color: #fff !important;
  font-size: 20px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.record-sign {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: red;
  box-shadow: 0 0 5px red;
}

.separator-wrapper {
  position: absolute;
  height: 100%;
  top: 0;
  left: 50%;
  margin-left: -3px;
  padding-bottom: 10px;
  width: 6px;
}

.separator-line {
  border-left: 2px dashed red;
  height: 100%;
  position: relative;
}
</style>
